import React from 'react';
import {
  resetModalConfig,
  setModalConfig,
} from '../../../../redux/actions/modal';
import { StateModel } from '../../../../redux/store';
import { connect } from 'react-redux';

interface TableCellSliderCheckboxProps {
  value: any;
  onClickHandler: any;
  onChangeHandler: any;
  rowIndex?: number;
  tabIndex: number;
  isSelected?: number | null;
  labelActive?: string;
  labelInactive?: string;
  tooltip?: string;
  name: string;
  SpecificModal?: any;
  setModalConfig: (value: any, fieldName: string) => void;
  useAsButton?: boolean;
  disabled?: boolean;
  resetModalConfig: () => void;
  hierarchicalAttributename?: string;
}

/**
 * Komponente für jede einzelene Zelle einer {@link Table.jsx}
 *
 * @param name - Html Name des Elementes
 * @param value Html Value des Elementes
 * @param onClickHandler  on click handler
 * @param rowIndex Zeilenindex
 * @param tabIndex tab index (auch -1 or 0), definiert die Tabreihenfolge
 * @param isSelected ob die Reihe, in dem sich das Feld befindet, ausgewählt ist
 * @returns {JSX.Element}
 * @constructor
 */
const TableCellSliderCheckbox = ({
  value = false,
  onClickHandler,
  onChangeHandler,
  rowIndex,
  tabIndex = 0,
  labelActive = 'Ja',
  labelInactive = 'Nein',
  isSelected,
  tooltip,
  name,
  SpecificModal,
  setModalConfig,
  useAsButton = false,
  disabled = false,
  resetModalConfig,
  hierarchicalAttributename,
}: TableCellSliderCheckboxProps) => {
  /**
   * OnClick-Handler.
   * Definiert die Aktion, die ausgeführt wird, wenn das Element angeklickt wurde.
   */
  const onClick = () => {
    onClickHandler(rowIndex);
    if (SpecificModal) {
      resetModalConfig();
      setModalConfig(
        <SpecificModal rowIndex={rowIndex}></SpecificModal>,
        'children'
      );
      setModalConfig(true, 'show');
    }
  };

  /**
   * Definiert die Aktion, die ausgeführt wird, wenn sich das Element verändert.
   * @see https://developer.mozilla.org/de/docs/Web/API/HTMLElement/change_event
   *
   * @param event Html Event
   */
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!useAsButton) {
      const onChangeValue = event.target.checked;
      onChangeHandler(
        event.target.name,
        onChangeValue,
        rowIndex,
        hierarchicalAttributename
      );
    }
  };

  return (
    <label className='switch' title={tooltip ?? ''}>
      <input
        className={`${isSelected === rowIndex ? 'row-selected' : ''}`}
        type='checkbox'
        tabIndex={tabIndex}
        value={value}
        checked={value}
        onChange={e => onChange(e)}
        name={name}
        onClick={onClick}
        disabled={disabled}
      />

      <span className='slider round'>
        <span className='sliderdot'>{value ? labelActive : labelInactive}</span>
      </span>
    </label>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
});

export default connect(mapStateToProps, {
  setModalConfig,
  resetModalConfig,
})(TableCellSliderCheckbox);
